import { Vue, debounce } from './config'

if (document.getElementById('help')) {
    new Vue({
        el: '#help',
        components: {
        },
        data: {
            rootId: 0,
            loading: false,
            query: '',
            results: [],
            qResults: []
        },
        watch: {
            query: debounce(function (q) {
                this.doSearch()
            }, 500)
        },
        methods: {
            setCat(id) {
                this.catId = id
                this.doSearch()
            },
            doSearch() {
                var vm = this
                this.loading = true
                vm.doPost('/umbraco/api/help/search', { helpRoot: vm.rootId, query: vm.query }, (data) => {
                    vm.results = data.articles
                    vm.qResults = data.faqs
                    vm.loading = false

                })
            },
        },
        mounted() {
            var vm = this
            vm.rootId = vm.$el.dataset.root
            vm.doSearch()
        }
    })
}